module.exports = __webpack_public_path__ + "static/img/04.eedf0304.png";